import * as React from 'react';
import {useState} from 'react';
import Head from '~/common/layout/Head';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import cx from 'classnames';

const SalesListHeader = (props) => {
  const {
    statusHelper,
    filter,
    onStatusChange,
    onFilter,
    onCreate,
  } = props;
  const [queryFilter, setQueryFilter] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  let options;
  if (filter.status) {
    options = [{ value: null, label: 'Remove Filter' }].concat(statusHelper.options);
  } else {
    options = statusHelper.options;
  }

  const onFilterSubmit = (e) => {
    e.preventDefault();
    onFilter(queryFilter);
  }

  const handleQueryChange = (e) => {
    setQueryFilter(e.target.value)
  }

  const handleStatusChange = (option) => {
    onStatusChange(option.value)
  }

  const handleOnCreate = (e) => {
    e.preventDefault();
    onCreate();
  }

  const onExport = (e) => {
    e.preventDefault();

    if (startDate && endDate) {
      props.onExport(startDate, endDate);
    }
  };

  const btnClass = cx('btn btn--disabled btn--tert btn--lg', {
    'btn--disabled--active': startDate && endDate && startDate <= endDate,
  });

  return (
    <Head headTitle="Sales">
      {props.onExport && (
        <React.Fragment>
          <div className="input--date">
            <DatePicker
              onChange={setStartDate}
              selected={startDate}
              popperPlacement="bottom-end"
              placeholderText="Start Date" />
          </div>
          <div className="btn btn--text--di btn--lg">TO</div>
          <div className="input--date">
            <DatePicker
              onChange={setEndDate}
              selected={endDate}
              popperPlacement="bottom-end"
              placeholderText="End Date" />
          </div>
          <a href="#" className={btnClass} onClick={onExport}>Export</a>
        </React.Fragment>
      )}

      <ReactSelect
        name="status"
        label="Status"
        className="filter--drop --md"
        placeholder="Filter Status"
        classNamePrefix="filter--drop"
        value={statusHelper.getSelectValue(filter.status)}
        options={options}
        onChange={handleStatusChange}
        onInputChange={statusHelper.search}
        isLoading={!!statusHelper.isLoading}
      />

      <form onSubmit={onFilterSubmit}>
        <div className="input--search input--md">
          <a onClick={onFilterSubmit} href="javascript:void(null)" className="input__icon input--search__btn">
            <span className="i i-search" />
          </a>
          <input
            type="text"
            placeholder="Search"
            onChange={handleQueryChange}
            defaultValue={filter && filter.q}
          />
        </div>
      </form>
      <a
        onClick={handleOnCreate}
        href="#"
        className="btn btn--secn btn--lg">New Sale</a>
    </Head>
  );
}

export default SalesListHeader
